/**
 * Разворачивает вложенное хранилище forms `{elementId: fields}` в плоскую карту полей.
 * Не разворачивает typed UniData `{type, value}` — иначе в корень попадают ключи `type`/`value`
 * (27534 putPanelData → execute-procedure timeout).
 */

export function isTypedUniDataFieldEnvelope(value: unknown): boolean {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false
  const v = value as { type?: unknown; value?: unknown }
  return typeof v.type === 'string' && Object.prototype.hasOwnProperty.call(v, 'value')
}

export function flattenFormStorageMap(
  obj: unknown,
  level: number,
): Record<string, unknown> {
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) {
    if (typeof obj === 'string') {
      return {}
    }
    return (obj as Record<string, unknown>) || {}
  }

  let result: Record<string, unknown> = { ...(obj as Record<string, unknown>) }
  for (let i = 0; i < level; i++) {
    if (!result || typeof result !== 'object' || Array.isArray(result)) {
      break
    }

    const beforeKeys = Object.keys(result)
    result = Object.keys(result).reduce((acc, key) => {
      const value = result[key]
      if (value && typeof value === 'object' && !Array.isArray(value) && !isTypedUniDataFieldEnvelope(value)) {
        return { ...acc, ...(value as Record<string, unknown>) }
      }
      acc[key] = value
      return acc
    }, {} as Record<string, unknown>)

    const afterKeys = Object.keys(result)
    if (beforeKeys.length > 0 && afterKeys.length === 0) {
      return { ...(obj as Record<string, unknown>) }
    }
  }

  return result
}
